var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-contents"
  }, [_c('div', {
    class: [_vm.$style.graduationContainer],
    style: {
      bottom: _vm.bottomOffset + 'px'
    },
    on: {
      "click": _vm.startTutorialFn
    }
  }, [_c('MottoIcon', {
    class: _vm.$style.graduationCap,
    attrs: {
      "name": "GraduationCap",
      "icon-color": "white"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }